import { render, staticRenderFns } from "./MemoryDebugger.vue?vue&type=template&id=7107c177&scoped=true&"
import script from "./MemoryDebugger.vue?vue&type=script&lang=ts&"
export * from "./MemoryDebugger.vue?vue&type=script&lang=ts&"
import style0 from "./MemoryDebugger.vue?vue&type=style&index=0&id=7107c177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7107c177",
  null
  
)

export default component.exports